/* eslint-disable no-console */
import React from 'react'
import { Row, Col, Button, Alert } from 'antd'
import DeleteIcon from '../../../../../assets/images/wnb/clear-bins-icon.svg'
import AcContainer from './acContainer'

const AcType339 = (props) => {
  const INPUTDISABLED = props.ccPlanModalVisible || props.copy || props.disableInputs
  const ULDDISABLED = props.disableInputs || props.copy

  let uldAssigned = []
  const getUld = (uld_type, wgt) => {
    let ld2 = ['DPA', 'DPE', 'DPL', 'DPN']
    let ld3 = ['AKE', 'AKN', 'AKX', 'AKY']
    const find = uld_type && props.ulds?.find(uld => {
      let uld_wgt = Math.round(parseFloat(uld.wgt))
      if(props.wgt_unit == 'KG')
      {
        // kg to lbs
        wgt = wgt * 2.20462262
      }
      wgt = Math.round(parseFloat(wgt))
      if (uld_type == uld?.uld_type?.substring(0, 3) && uld_wgt == wgt && !uldAssigned.includes(uld.id)) {
        uldAssigned.push(uld.id)
        return true
      }
      if (uld_type == 'LD2' && ld2.includes(uld?.uld_type?.substring(0, 3)) && uld_wgt == wgt && !uldAssigned.includes(uld.id)) {
        uldAssigned.push(uld.id)
        return true
      }
      if (uld_type == 'LD3' && ld3.includes(uld?.uld_type?.substring(0, 3)) && uld_wgt == wgt && !uldAssigned.includes(uld.id)) {
        uldAssigned.push(uld.id)
        return true
      }
    })
    return find ? find.uld_type : ''
  }


  return (
    <div>
      <div className='WnB-alert'>
        {props?.optimal === true && (<Alert type='success' className='WnB-alert-success' message='Optimal Configuration' showIcon />)}
        {props?.optimal !== true && (<Alert type='error' className='WnB-alert-error' message={props?.optimal || 'Suboptimal Configuration'} showIcon />)}
      </div>

      <div className={`parent-div-339-1 ${props.viewMode == 'sm' ? 'parent-div-339-sm' : ''}`}>
        <div className='ac-top-wrapper'>
          <div className='container-wrapper airline-ac339-top'>
            <Row gutter={[0]} wrap={false}>
              {/* LHS */}
              <Col flex='840px'>
                <Row gutter={[4]} wrap={false}>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339'
                      name='41P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p41}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p41', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p41, props.position?.pallet?.p41)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p41}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p41', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r42 || props.position?.cargo?.l42 || props.position?.cargo?.r41 || props.position?.cargo?.l41}
                      // isBag={props.bag_wgt == props.position?.pallet?.p41} 
                      className={`${props.position?.pallet?.p41 && !props.position?.pallet?.p34 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339'
                      name='34P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p34}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p34', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p34, props.position?.pallet?.p34)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p34}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p34', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r35 || props.position?.cargo?.l35 || props.position?.cargo?.r41 || props.position?.cargo?.l41}
                      // isBag={props.bag_wgt == props.position?.pallet?.p34} 
                      className={`${props.position?.pallet?.p34 && !props.position?.pallet?.p41 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339'
                      name='33P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p33}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p33', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p33, props.position?.pallet?.p33)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p33}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p33', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r34 || props.position?.cargo?.l34 || props.position?.cargo?.r33 || props.position?.cargo?.l33}
                      // isBag={props.bag_wgt == props.position?.pallet?.p33} 
                      // className={`${props.position?.pallet?.p33 && !props.position?.pallet?.p32 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                </Row>
              </Col>
              {/* Mid */}
              <Col flex='100px' className='f-middle'>
                <Button className='bin-button' onClick={props.clearBin} icon={<div className='bin-icon'><img src={DeleteIcon} alt='delete' /></div>}></Button>
              </Col>
              {/* RHS */}
              <Col flex='960px'>
                <Row gutter={[4]} wrap={false}>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339'
                      name='25P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p25}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p25', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p25, props.position?.pallet?.p25)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p25}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p25', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r27 || props.position?.cargo?.l27 || props.position?.cargo?.r26 || props.position?.cargo?.l26}
                      // isBag={props.bag_wgt == props.position?.pallet?.p25} 
                      className={`${props.position?.pallet?.p25 && !props.position?.pallet?.p24 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339'
                      name='24P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p24}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p24', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p24, props.position?.pallet?.p24)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p24}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p24', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r25 || props.position?.cargo?.l25 || props.position?.cargo?.r26 || props.position?.cargo?.l26}
                      // isBag={props.bag_wgt == props.position?.pallet?.p23} 
                      className={`${props.position?.pallet?.p24 && !props.position?.pallet?.p25 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339'
                      name='23P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p23}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p23', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p23, props.position?.pallet?.p23)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p23}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p23', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r23 || props.position?.cargo?.l23 || props.position?.cargo?.l24 || props.position?.cargo?.r24}
                      // isBag={props.bag_wgt == props.position?.pallet?.p23}      
                      className={`${props.position?.pallet?.p23 && !props.position?.pallet?.p22 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339' name='22P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p22}
                      uldOnChange={(e) => props.onChange(e, 'p22', 'pallet_uld')}
                      uld={getUld(props.position?.pallet_uld?.p22, props.position?.pallet?.p22)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p22}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p22', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r22 || props.position?.cargo?.l22 || props.position?.cargo?.r23 || props.position?.cargo?.l23}
                      className={`${props.position?.pallet?.p22 && !props.position?.pallet?.p23 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339' name='21P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p21}
                      uldOnChange={(e) => props.onChange(e, 'p21', 'pallet_uld')}
                      uld={getUld(props.position?.pallet_uld?.p21, props.position?.pallet?.p21)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p21}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p21', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r12 || props.position?.cargo?.l12 || props.position?.cargo?.l21 || props.position?.cargo?.r21}
                      className={`${props.position?.pallet?.p21 && !props.position?.pallet?.p11 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='339' name='11P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p11}
                      uldOnChange={(e) => props.onChange(e, 'p11', 'pallet_uld')}
                      uld={getUld(props.position?.pallet_uld?.p11, props.position?.pallet?.p11)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p11}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p11', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r11 || props.position?.cargo?.l11 || props.position?.cargo?.l12 || props.position?.cargo?.r12}
                      className={`${props.position?.pallet?.p11 && !props.position?.pallet?.p21 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
        <div className='airline-ac-contents'>
          <div className='container-wrapper'>
            <Row gutter={[0]} wrap={false}>
              {/* LHS */}
              <Col flex='840px'>
                <Row gutter={[8, 16]}>
                  {/* TOP ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339' name='BULK'
                          ipDisabled={ULDDISABLED}
                          ipValue={props.position?.bulk}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, null, 'bulk')}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='43L'
                          uldSelect={true}
                          onePair={true}
                          uldValue={props.position?.cargo_uld?.l43}
                          uldOnChange={(e) => props.onChange(e, 'l43', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l43,
                            props.position?.cargo?.l43
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l43}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l43', 'cargo')}
                          ipDisabled={INPUTDISABLED}
                          isBag={props.bag_wgt == props.position?.cargo?.l43}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='42L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l42}
                          uldOnChange={(e) => props.onChange(e, 'l42', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l42,
                            props.position?.cargo?.l42
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l42}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l42', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p41}
                          isBag={props.bag_wgt == props.position?.cargo?.l42}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='41L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l41}
                          uldOnChange={(e) => props.onChange(e, 'l41', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l41,
                            props.position?.cargo?.l41
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l41}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l41', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34 || props.position?.pallet?.p41}
                          isBag={props.bag_wgt == props.position?.cargo?.l41}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='35L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l35}
                          uldOnChange={(e) => props.onChange(e, 'l35', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l35,
                            props.position?.cargo?.l35
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l35}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l35', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34}
                          isBag={props.bag_wgt == props.position?.cargo?.l35}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='34L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l34}
                          uldOnChange={(e) => props.onChange(e, 'l34', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l34,
                            props.position?.cargo?.l34
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l34}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l34', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p33}
                          isBag={props.bag_wgt == props.position?.cargo?.l34}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='339'
                          name='33L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l33}
                          uldOnChange={(e) => props.onChange(e, 'l33', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l33,
                            props.position?.cargo?.l33
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l33}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l33', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p32 || props.position?.pallet?.p33}
                          isBag={props.bag_wgt == props.position?.cargo?.l33}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {/* BOTTOM ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex={'120px'}></Col>
                      <Col flex={'120px'}></Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339' name='42R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r42}
                          uldOnChange={(e) => props.onChange(e, 'r42', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l42,
                            props.position?.cargo?.r42
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r42}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r42', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p41 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l42)}
                          isBag={props.bag_wgt == props.position?.cargo?.r42}
                        />
                      </Col>

                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='41R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r41}
                          uldOnChange={(e) => props.onChange(e, 'r41', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l41,
                            props.position?.cargo?.r41
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r41}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r41', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34 || props.position?.pallet?.p41 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l41)}
                          isBag={props.bag_wgt == props.position?.cargo?.r41}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='35R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r35}
                          uldOnChange={(e) => props.onChange(e, 'r35', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l35,
                            props.position?.cargo?.r35
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r35}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r35', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l35)}
                          isBag={props.bag_wgt == props.position?.cargo?.r35}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='34R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r34}
                          uldOnChange={(e) => props.onChange(e, 'r34', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l34,
                            props.position?.cargo?.r34
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r34}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r34', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p33 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l34)}
                          isBag={props.bag_wgt == props.position?.cargo?.r34}

                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='33R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r33}
                          uldOnChange={(e) => props.onChange(e, 'r33', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l33,
                            props.position?.cargo?.r33
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r33}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r33', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p32 || props.position?.pallet?.p33 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l33)}
                          isBag={props.bag_wgt == props.position?.cargo?.r33}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              {/* Mid */}
              <Col flex='100px'>
              </Col>
              {/* RHS */}
              <Col flex='960px'>
                <Row gutter={[8, 16]}>
                  {/* TOP ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339' name='27L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l27}
                          uldOnChange={(e) => props.onChange(e, 'l27', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l27,
                            props.position?.cargo?.l27
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l27}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l27', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p25}
                          isBag={props.bag_wgt == props.position?.cargo?.l27}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='26L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l26}
                          uldOnChange={(e) => props.onChange(e, 'l26', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l26,
                            props.position?.cargo?.l26
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l26}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l26', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24 || props.position?.pallet?.p25}
                          isBag={props.bag_wgt == props.position?.cargo?.l26}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='25L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l25}
                          uldOnChange={(e) => props.onChange(e, 'l25', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l25,
                            props.position?.cargo?.l25
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l25}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l25', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24}
                          isBag={props.bag_wgt == props.position?.cargo?.l25}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='24L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l24}
                          uldOnChange={(e) => props.onChange(e, 'l24', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l24,
                            props.position?.cargo?.l24
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l24}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l24', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p23}
                          isBag={props.bag_wgt == props.position?.cargo?.l24}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339'
                          name='23L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l23}
                          uldOnChange={(e) => props.onChange(e, 'l23', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l23,
                            props.position?.cargo?.l23
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l23}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l23', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22 || props.position?.pallet?.p23}
                          isBag={props.bag_wgt == props.position?.cargo?.l23}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='339'
                          name='22L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l22}
                          uldOnChange={(e) => props.onChange(e, 'l22', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l22,
                            props.position?.cargo?.l22
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l22}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l22', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22}
                          isBag={props.bag_wgt == props.position?.cargo?.l22}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='339'
                          name='21L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l21}
                          uldOnChange={(e) => props.onChange(e, 'l21', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l21,
                            props.position?.cargo?.l21
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l21}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l21', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p21}
                          isBag={props.bag_wgt == props.position?.cargo?.l21}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='339'
                          name='12L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l12}
                          uldOnChange={(e) => props.onChange(e, 'l12', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l12,
                            props.position?.cargo?.l12
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l12}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l12', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11 || props.position?.pallet?.p21}
                          isBag={props.bag_wgt == props.position?.cargo?.l12}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='339'
                          name='11L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l11}
                          uldOnChange={(e) => props.onChange(e, 'l11', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l11,
                            props.position?.cargo?.l11
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l11}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l11', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11}
                          isBag={props.bag_wgt == props.position?.cargo?.l11}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {/* BOTTOM ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='339' name='27R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r27}
                          uldOnChange={(e) => props.onChange(e, 'r27', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l27,
                            props.position?.cargo?.r27
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r27}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r27', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p25 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l27)}
                          isBag={props.bag_wgt == props.position?.cargo?.r27}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='26R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r26}
                          uldOnChange={(e) => props.onChange(e, 'r26', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l26,
                            props.position?.cargo?.r26
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r26}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r26', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24 || props.position?.pallet?.p25 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l26)}
                          isBag={props.bag_wgt == props.position?.cargo?.r26}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339' name='25R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r25}
                          uldOnChange={(e) => props.onChange(e, 'r25', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l25,
                            props.position?.cargo?.r25
                          )}
                          // position={props.position}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r25}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r25', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l25)}
                          isBag={props.bag_wgt == props.position?.cargo?.r25} />
                      </Col>

                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='24R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r24}
                          uldOnChange={(e) => props.onChange(e, 'r24', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l24,
                            props.position?.cargo?.r24
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r24}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r24', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p23 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l24)}
                          isBag={props.bag_wgt == props.position?.cargo?.r24}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='23R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r23}
                          uldOnChange={(e) => props.onChange(e, 'r23', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l23,
                            props.position?.cargo?.r23
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r23}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r23', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22 || props.position?.pallet?.p23 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l23)}
                          isBag={props.bag_wgt == props.position?.cargo?.r23}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='22R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r22}
                          uldOnChange={(e) => props.onChange(e, 'r22', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l22,
                            props.position?.cargo?.r22
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r22}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r22', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l22)}
                          isBag={props.bag_wgt == props.position?.cargo?.r22}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339' name='21R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r21}
                          uldOnChange={(e) => props.onChange(e, 'r21', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l21,
                            props.position?.cargo?.r21
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r21}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r21', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p21 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l21)}
                          isBag={props.bag_wgt == props.position?.cargo?.r21} />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='12R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r12}
                          uldOnChange={(e) => props.onChange(e, 'r12', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l12,
                            props.position?.cargo?.r12
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r12}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r12', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11 || props.position?.pallet?.p21 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l12)}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='339'
                          name='11R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r11}
                          uldOnChange={(e) => props.onChange(e, 'r11', 'cargo_uld')}
                          uld={getUld(
                            props.position?.cargo_uld?.l11,
                            props.position?.cargo?.r11
                          )}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r11}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r11', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11 || ['PLA', 'PLB', 'FLA'].includes(props.position?.cargo_uld?.l11)}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className='door-block'>
              <Row gutter={[0]} wrap={false}>
                {/* LHS */}
                <Col flex='840px'>
                  <Row gutter={[4]} wrap={false}>
                    <Col flex={'120px'}></Col>
                    <Col flex={'120px'}></Col>
                    <Col flex='1.5 1 0'><div className='doors'>Door</div></Col>
                    <Col flex='0.5 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                  </Row>
                </Col>
                {/* Mid */}
                <Col flex='100px'>
                </Col>
                {/* RHS */}
                <Col flex='960px'>
                  <Row gutter={[4]} wrap={false}>
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='0.5 1 0' />
                    <Col flex='1.5 1 0'><div className='doors'>Door</div></Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <ul className=''>
        <li>Plan heavy containers for the AFT compartment:</li>
        <li> 1 x heavy PMC, 1 x heavy PAG, & 5 x heavy AKE</li>
      </ul>
    </div>
  )
}
export default AcType339
